export default __webpack_public_path__ + "static/Mobius-a9b68b02975de423df2a581e07888af7.webp";